<ul class="user-info-bar topbar-right d-flex flex-row gap-12" rol="list">
    <!-- Luca -->
    <!--        @if(acl && !acl.isClient){-->
    <!--            <li role="listitem" class="user-info-item luca-responsive-icon">-->
    <!--                <div #showLuca></div>-->
    <!--                @defer (on viewport(showLuca)) {-->
    <!--                    <app-luca-launcher></app-luca-launcher>-->
    <!--                }-->
    <!--            </li>-->
    <!--        }-->

    @if (acl && !acl.isClient) {
        <li role="listitem" class="user-info-item luca-responsive-icon">
            <div #showLuka></div>
            @defer (on viewport(showLuka)) {
                <luka-launcher></luka-launcher>
            }
        </li>
    }

    <!-- Switch firms -->
    <ng-container *ngIf="acl && user?.hasMultipleFirm">
        <li role="listitem" class="user-info-item">
            <button class="nav-item tooltip-bottom" (click)="openFirmSwitchDialog('switchFirm')">
                <span class="nav-icon" matBadgeColor="warn">
                    <i class="fa-regular fa-buildings text-white fs-15"></i>
                </span>
                <!-- <span class="nav-label text-white">{{ firmShortName() }} <i class="fa-regular fa-angle-right text-white"></i> </span> -->
                <span class="nav-label">{{firm?.name}}</span>
            </button>
        </li>
    </ng-container>

    <!-- Notification -->
    <li role="listitem" class="user-info-item notification-count" *ngIf="acl && firm.onboarded"        
        [ngClass]="{'disable-container-list': mfaMandatory || firm.isAccountLockedForBilling}">
        <button class="nav-item tooltip-bottom label-bottom text-white" aria-label="Notifications"
        [disabled]="firm?.isDeleted"
            [ngClass]="{'badge-count': notifyCount > 99, 'badge-count1': notifyCount > 999 }"
            [matMenuTriggerFor]="notifications" #unreadPushNotification="matMenuTrigger" (click)="closeMenu()">
            <span class="nav-icon" matBadge="{{notifyCount > 9 ? '9+' : notifyCount > 0 ? notifyCount : ''}}"
                matBadgePosition="above after" [matBadgeHidden]="isNotificationOn" matBadgeColor="warn">
                <i class="fa-solid fa-bell fs-20"></i>
                <!-- <img src="/assets/images/ui-uplift-icons/global/nav-icons/notification.svg" alt="Icon"> -->
            </span>
            <span class="nav-label">Notifications</span>
            <mat-menu #notifications="matMenu" class="notifications-container" #beforeMenu="matMenu" xPosition="before">
                <div #loadNotifications></div>
                @defer (on viewport(loadNotifications)) {
                <notifications></notifications>
                }
            </mat-menu>
        </button>
    </li>

    <!-- Support -->
    <li class="user-info-item align-self-center" role="listitem" (click)="check()">
        @if(!profilePic()) {
        <button class="nav-item" #menuTriggerForUser="matMenuTrigger" class="picUpdated custom-profile-btn"
            [matMenuTriggerFor]="!saveChangeStatus ? menu : null"
            (click)="closeMenu()">
            <ngx-avatars  initialsSize="2" [bgColor]="userBackgroundColor()" size="28" fgColor="rgba(0, 0, 0, 0.8)"
                [name]="user?.fullName"></ngx-avatars>
                
            <i class="fa-solid fa-caret-down text-white"></i>
        </button>    
        } @else {
             <button class="nav-item" #menuTriggerForUser="matMenuTrigger" class="picUpdated custom-profile-btn"
            [matMenuTriggerFor]="!saveChangeStatus ? menu : null"
            (click)="closeMenu()">
            <div #menuTriggerForUser="matMenuTrigger"
                [matMenuTriggerFor]="!saveChangeStatus ? menu : null" class="picUpdated">
                <img [src]="profilePic()" alt="profile pic" class="headerImage br-28" style="max-width: 28px; max-height:28px;" />
            </div>
            <i class="fa-solid fa-caret-down text-white"></i>
        </button> 
        }
        
        <mat-menu class="user-dropdownnn user-menu-main user-menu-main-v1" #menu="matMenu" #beforeMenu="matMenu">
            <div [ngClass]="{'py-2' : firm.onboarded}">
                <ng-container *ngIf="acl?.isClient; else otherUsers">
                <span class="profile-group">
                    <button mat-menu-item [ngClass]="{'disable' : firm?.isAccountLockedForBilling}" routerLink="/dashboard/clients/client-settings" class="px-2">
                        <ngx-avatars size="30" [name]="user.fullName" initialsSize="2"></ngx-avatars>
                        <span class="my-account">My Account</span>
                    </button>
                    <div class="icon-border">
                        <button mat-menu-item routerLink="/dashboard/clients/client-settings" [disabled]="firm?.isAccountLockedForBilling" class="px-3">
                            <span class="flexbox-row gap-12">
                                 <i class="fa-regular fa-gear fs-20"></i>
                                <span>Settings</span>
                            </span>
                        
                        </button>
                        <button mat-menu-item class="icon-left px-3" [matMenuTriggerFor]="help">
                            <span class="flexbox-row gap-12">
                                <i class="fa-regular fa-message-question fs-20"></i>
                                <span class="button-label">Help</span>
                            </span>
                        </button>

                       <button mat-menu-item (click)="logout()" class="px-3">
                        <span class="flexbox-row gap-12">
                            <i class="fa-regular fa-arrow-right-from-bracket fs-20"></i>
                            <span>Log out</span>
                        </span>
                         </button>

                        <mat-menu #help="matMenu" class="video-menu user-submenu-v1">
                            <button mat-menu-item routerLink="/dashboard/help/support">Contact Support</button>
                        </mat-menu>
                    </div>      
                </span>
                
            </ng-container>
            <!--Partner staff members menu items-->
            <ng-template #otherUsers>
                <span class="profile-group border-bottom">
                @if(!profilePic()) {
                <button mat-menu-item (click)="openContextWindow(0)" [ngClass]="{'mandatedisable': mfaMandatory}"
                    [disabled]="firm?.isAccountLockedForBilling" *ngIf="firm?.onboarded && !firm?.isAccountLockedForBilling"
                    class="px-2">
                    <ngx-avatars initialsSize="2" [bgColor]="userBackgroundColor()" size="30" fgColor="rgba(0, 0, 0, 0.8)"
                        [name]="user?.fullName"></ngx-avatars><span>My Account</span>
                </button>
                } @else {
                <button mat-menu-item (click)="openContextWindow(0)" *ngIf="firm?.onboarded && !firm?.isAccountLockedForBilling"
                    class="px-2" [ngClass]="{'mandatedisable': mfaMandatory}" [disabled]="firm?.isAccountLockedForBilling">
                    <div class="picUpdated">
                        <img [src]="profilePic()" alt="profile pic" *ngIf="profilePic()" class="headerImage my-account-img" style="max-width:30px; max-height: 30px;" />
                    </div>
                    <span>My Account</span>
                </button>
                }

                       <button mat-menu-item class="px-3 mb-2" (click)="openContextWindow(1)"
                       *ngIf="firm && acl && firm.onboarded && acl.hasBilling">
                            <span class="flexbox-row gap-16">
                               <i class="fa-regular fa-building fs-20"></i>
                                <span>Firm Profile</span>
                            </span>
                        </button>
                </span>
              
                <div class="icon-border profile-group border-bottom" [ngClass]="{'mandatedisable': mfaMandatory}">
                    <button mat-menu-item (click)="openContextWindow(0)"
                        [ngClass]="{'mandatedisable': mfaMandatory}" [disabled]="firm?.isAccountLockedForBilling"
                        *ngIf="firm && firm?.onboarded && !firm?.isAccountLockedForBilling" class="px-3 mt-2">
                        <span class="flexbox-row gap-12">
                        <i class="fa-regular fa-gear fs-18"></i>
                        <span>Settings</span>
                        </span>
                       
                    </button>
                    <button mat-menu-item (click)="navigateToRoute('Billing')"
                        [ngClass]="{'mandatedisable': mfaMandatory}" [disabled]="firm.isDeleted"
                        *ngIf="firm && acl && firm.onboarded && acl.hasBilling" class="px-3">
                        <span class="flexbox-row gap-12">
                            <i class="fa-regular fa-credit-card fs-18"></i>
                            <span>Billing</span>
                        </span>
                    </button>
                    @if(userDetail && userDetail.useraccesstypeid === 2 && firm.onboarded) {
                    <button mat-menu-item class="px-3 mb-2" (click)="navigateToRoute('integrations')">
                        <span class="flexbox-row gap-10">
                            <i class="fa-regular fa-laptop-code fs-18"></i>
                            <span>Apps & Integrations</span>
                            <span class="badge badge-pink badge-pills badge-small">New</span>
                        </span>
                    </button>              
                    }
                </div>
                <span class="profile-group">
                       <button mat-menu-item class="px-3 mt-2" (click)="openTermsPrivacyDialog('terms-of-Use')"
                       *ngIf="firm && acl && firm.onboarded && acl.hasBilling">
                        <span class="flexbox-row gap-16">
                            <i class="fa-regular fa-file-contract fs-20"></i>
                            <span>Terms & Condition </span>
                        </span>
                    </button>
                       <button mat-menu-item class="px-3" (click)="openTermsPrivacyDialog('privacy-policy')"
                       *ngIf="firm && acl && firm.onboarded && acl.hasBilling">
                        <span class="flexbox-row gap-12">
                            <i class="fa-regular fa-building-shield fs-20"></i>
                            <span>Privacy Policy</span>
                        </span>
                    </button>
                       <button mat-menu-item (click)="logout()" class="px-3">
                        <span class="flexbox-row gap-14">
                            <i class="fa-regular fa-arrow-right-from-bracket fs-20"></i>
                            <span>Log out</span>
                        </span>
                
                         </button>
                </span>
            </ng-template>
            </div>
            
        </mat-menu>
    </li>
</ul>



<!-- Overdue Notifications -->
<div class="unread-notification" *ngIf="acl?.isClient && showOverDueNotifications">
    <p class="message no-marg">You have <span class="convo">{{notifyOverdueCount}}</span> overdue requests</p>
    <div class="preview-hover-items">
        <button mat-button class="transparent-btn more-btn no-pad vert-icon">
            <i class="fa-regular fa-xmark clear-icon" (click)="closeOverDuePushNotification();"></i>
        </button>
    </div>
</div>
<!-- reminder count  Notifications for client -->
<ng-container *ngIf="acl?.isClient && showReminderNotifications">
    <div class="unread-notification" [ngClass]="{'overdue-reminder-pop': showOverDueNotifications && showReminderNotifications && acl?.isClient,
              'reminder-pop': !showOverDueNotifications && showReminderNotifications && acl?.isClient}">
        <p class="message no-marg">You have <span class="convo">{{notifyReminderCount}}</span> reminder notifications
        </p>
        <div class="preview-hover-items">
            <button mat-button class="transparent-btn more-btn no-pad vert-icon"
                (click)="closeReminderPushNotification();">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
    </div>
</ng-container>
<!-- Unread Notifications -->
<div class="unread-notification" *ngIf="showUnreadNotifications">
    <p class="message no-marg">You have <span class="convo">{{notifyCount}}</span> unread notifications</p>
    <div class="preview-hover-items">
        <button mat-button class="transparent-btn more-btn no-pad vert-icon" (click)="closePushNotification();">
            <i class="fa-regular fa-xmark clear-icon"></i>
        </button>
    </div>
</div>

<!-- Overlay -->
 @if(isContextWindowOpen()) {
 <div class="overlay">
    <div class="setting-popup" [ngClass]="{'setting-popup-show' : isContextWindowOpen()}">
        <app-settings-overlay (closeOverlay)="closeContextWindow()" [inputSettings]="toggleSettingsOverlay"></app-settings-overlay>
    </div>
</div>
 }

<ng-template #switchFirmDialog>
    <!-- Switch Firms -->
    @if(firm && !selectedFirm){
    <div class="countable-dialog">
        <div class="dialog-header">
            <span class="border br-8 p-2"><i class="fa-regular fa-person-walking-arrow-right"></i></span>
            <button class="transparent-btn close" aria-label="Close" mat-dialog-close type="button">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
            <h5>Switch Firm To</h5>
            <p>Firms who have assigned you to engagements </p>
            <mat-form-field class="fixed-label label-none flex-1 icon-form-before w-100" floatLabel="always">
                <mat-label>Search</mat-label>
                <input matInput placeholder="Search" maxlength="50" [formControl]="firmSearch" autocomplete="off">
                <span matPrefix>
                    <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                </span>
            </mat-form-field>
        </div>
        <div class="dialog-body-content gap-20 overflow-hidden p-0">
            <div class="sticky overflow-auto p-3 switch-hgt">
                <ng-container *ngFor="let item of firms">
                    <p *ngIf="firmSearch?.value && firmSearch.value.trim().length ? item.name.toLowerCase().includes(firmSearch.value.toLowerCase()) : true"
                        class="d-flex justify-content-between align-items-center py-2">
                        <span class="d-flex align-items-center">
                            <ngx-avatars fgColor="#000000" bgColor="#E2E5EB" initialsSize="2" size="32"
                                [name]="item.name"></ngx-avatars>
                            <span class="px-2">{{ item.name }}</span>
                        </span>
                        <button [disabled]="item.hash === firm.hash" mat-button mat-flat-button color="secondary"
                            class="button-default" (click)="markTheFirmAsSelected(item)"
                            [ngClass]="{'button-large px-3' : item.hash === firm.hash }">
                            <span *ngIf="!(item.hash === firm.hash)">
                                <i class="fa-regular fa-file-export"></i>
                            </span>
                            {{ item.hash === firm.hash ? 'Logged As' : 'Login As' }}
                        </button>
                    </p>
                </ng-container>
            </div>
        </div>
    </div>
    }@else {
    <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center">
            <span class="badge badge-success badge-circle icon-bordered-success">
                <i class="fa-regular fa-arrow-right-to-arc"></i>
            </span>
            <button mat-button class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="content dialog-body-content text-center gap-20 mt-2 mb-32">
            <h4 class="title text-center">Switch Firms</h4>
            <p class="fw-medium">You are about to login into another firm</p>
            <p class="text-gray-6">Are you sure you would like to proceed with switching the firm?</p>
        </div>
        <div mat-dialog-actions class="dialog-footer flex-column" (click)="$event.stopPropagation()">
            <div class="button-group">
                <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">
                    Cancel
                </button>
                <button mat-button mat-flat-button class="button-default" color="primary" (click)="switchFirm()">Proceed
                </button>
            </div>
        </div>
    </div>
    }
</ng-template>

<!-- Unhealthy firm switch -->
<ng-template #unhealthyFirmSwitchDialog>
    <div class="countable-dialog confirmation-dailog">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title text-center">Login Temporarily Disabled</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-16 mt-2 mb-32">
            <p><strong>Due to unresolved payment concerns from your firm, login to the platform is restricted</strong>
            </p>
            <p>Please contact admin for further details</p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group">
            <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]="true">OK
            </button>
        </div>
    </div>
</ng-template>
